import { ColumnDef } from '@tanstack/react-table'
import { SortingHeaderButton } from '../../../../components/ui/DataTable/SortingHeaderButton'
import { ApplicationRoleItem } from '../AppRolesPage'
import { ApplicationRoleForm } from '../../Forms/ApplicationRoleForm'
import { Button } from '@/components/shadcn/button'
import { IconEditOutline } from '@icons/IconEditOutline'
import { NumberBadge } from '@/components/ui/DataTable/NumberBadge'
import { DeleteAppRoleConfirmDialog } from './DeleteAppRoleConfirmDialog'

export const appRolesColumns: ColumnDef<ApplicationRoleItem>[] = [
  {
    id: 'name',
    accessorFn: (row) => row.name.value,
    header: ({ column }) => <SortingHeaderButton column={column}>Role name</SortingHeaderButton>,
    cell: ({ cell }) => cell.getValue() as string,
    sortingFn: (rowA, rowB) => rowA.original.name.value.localeCompare(rowB.original.name.value),
    enableGlobalFilter: true,
    // size: 250,
  },
  {
    id: 'description',
    accessorFn: (row) => row.description.value,
    header: 'Role description',
    cell: ({ cell }) => cell.getValue() as string,
    enableGlobalFilter: true,
  },
  {
    id: 'memberCount',
    accessorFn: (row) => row.memberCount.value.toString(),
    header: 'Member count',
    cell: ({ row }) => <NumberBadge value={row.original.memberCount.value} />,
    enableGlobalFilter: true,
  },
  {
    id: 'teamCount',
    accessorFn: (row) => row.teamCount.value.toString(),
    header: 'Team count',
    cell: ({ row }) => <NumberBadge value={row.original.teamCount.value} />,
    enableGlobalFilter: true,
  },
  {
    id: 'actions',
    // header: 'Actions',
    enableGlobalFilter: false, // Don't include actions in search
    cell: ({ row }) => (
      <div className="flex justify-end gap-1">
        <ApplicationRoleForm
          sheetTitle="Edit application role"
          selectedAppRole={row.original}
          sheetTrigger={
            <Button size="icon" variant="ghost" aria-label="Edit role">
              <IconEditOutline className="size-4" />
            </Button>
          }
        />
        <DeleteAppRoleConfirmDialog role={row.original} />
      </div>
    ),
  },
]
